/**
 * Every list cache that embeds a canvas. Kept dependency-free so modules that
 * only need the keys (favorites, realtime) don't pull in the canvas API.
 */
export const CANVAS_LIST_QUERY_KEYS: string[][] = [
  ["canvases"],
  ["canvas"],
  ["workspaces"],
  ["workspace"],
];
